export const recalcItemIdsMapWorker = new Worker(
  new URL("../../webworkers/recalcItemIdsMap.worker.ts", import.meta.url)
);
